import React from 'react';
import { Link } from 'react-router-dom';
import ButtonTwo from '../Button/ButtonTwo';

import Image from '../../assets/img/service/service-5-1.jpg';

const SingleServiceSix = (props) => {
  const { itemClass, serviceImage, icon, title, description, btnText } = props;
  return (
    <div
      className={
        itemClass
          ? itemClass
          : 'it-service-4-item text-center z-index p-relative fix'
      }
    >
      <div className="it-service-4-thumb">
        <img src={serviceImage ? serviceImage : Image} alt="" />
      </div>
      <div className="it-service-4-icon pb-30">
        <span>
          <i className={icon ? icon : 'flaticon-microsurgery'}></i>
        </span>
      </div>
      <div className="it-service-4-content">
        <h4 className="it-service-4-title mb-25">
          <Link className="hover-anim white" to="/service-details">
            {title ? title : 'Heart Surgery'}
          </Link>
        </h4>
        <p className="mb-30">
          {description
            ? description
            : `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim`}
        </p>
        <ButtonTwo
          btnURL="/service-details"
          btnClass="it-btn-theme blog-btn red-bg mr-35"
          btnText={btnText ? btnText : 'More Details'}
        />
      </div>
    </div>
  );
};

export default SingleServiceSix;
